import { Button } from "@chakra-ui/react";
import { AiFillSchedule } from "react-icons/ai";
import { SiEnpass } from "react-icons/si";
import { CommonMethodService } from "../../Services/CommonMethodService";
import SetupPassword from "../../SetupPassword/SetUpPassword";
import { IBodyshopService } from "../../UserService";
import TabButtons from "./tab-buttons";
import { CurrentStatus } from "../../RepairTracker/CurrentStatus/CurrentStatus";
import { useCallback, useState } from "react";

const Dashboard = ({
  isAdmin,
  screens,
  handleSelectScreen,
  handleSetupPasswordDialog,
  isSetupPasswordDialog,
  estimateDetails,
  report,
  currProgress,
  dashboardSelectedTab,
  isEstimateVisible,
  handleDashboardSelectedTab,
  ibsAdonisService,
  notesSuggestions
}: any) => {
  const commonMethodService = new CommonMethodService();
  const ibsService = new IBodyshopService();
  const hasUserJobs = ibsService?.currentUser?.user?.userJob
    ? ibsService?.currentUser?.user?.userJob?.length > 0
    : false;
  const [, setRerender] = useState(0);

  const handleButtonClick = () => {
    commonMethodService.removeAllQueryParams();
    handleSelectScreen(screens.selectJob);
  };
  
  function getAugmentedNotes(notes: any[], currentUser: any) {
    return (notes || []).map(note => {
      return {
        ...note,
        userName: note?.user?.contactDetails?.displayName ? note?.user?.contactDetails?.displayName : (currentUser.name || "Unknown"),
        userImage: note?.user?.imageId ? note?.user?.imageId : null,
        userId: note?.user?.id
      };
    });
  }

  const augmentedNotes = getAugmentedNotes(
      estimateDetails.notes,
      ibsService.currentUser.user
    );

  const refreshNotes = useCallback(async () => {
    if (estimateDetails?.estimateId && ibsAdonisService) {
      try {
        const updatedDetails = await ibsAdonisService.getJobEstimateDetailsById(
          estimateDetails.estimateId
        );
        setRerender((prev) => prev + 1);
      } catch (e) {
        console.error("Failed to refresh notes", e);
      }
    }
  }, [estimateDetails, ibsAdonisService]);

  return (
    <>
      <div className="d-flex justify-content-between">
        {!isAdmin && (
          <div>
            <Button
              colorScheme="blue"
              disabled={!hasUserJobs}
              onClick={handleButtonClick}
            >
              <div className="d-flex align-items-center">
                <div>
                  {" "}
                  <AiFillSchedule
                    style={{
                      height: "1.5rem!important",
                      width: "1.5rem!important",
                    }}
                  />
                </div>
                <div>
                  <span style={{ fontSize: "0.9rem" }} className="btnText">
                    Your jobs
                  </span>
                </div>
              </div>
            </Button>
          </div>
        )}
        {!ibsService.currentUser?.user?.is_active && (
          <div>
            <Button
              className="d-flex align-items-center"
              colorScheme="red"
              onClick={() => handleSetupPasswordDialog(true)}
            >
              <div className="d-flex align-items-center">
                <div>
                  {" "}
                  <SiEnpass
                    style={{
                      height: "1.5rem!important",
                      width: "1.5rem!important",
                    }}
                  />
                </div>
                <div>
                  <span style={{ fontSize: "0.9rem" }} className="btnText">
                    Reset your password
                  </span>
                </div>
              </div>
            </Button>
          </div>
        )}
      </div>
      {/* <div className="dashboard-top-main">
        <button className="btn-myjob">My Job: {queryParams.get("estimateid")}</button>
        <div className="btn-dashboard-status">
          <span>Status:</span>
          <span>{queryParams.get("status")}</span>
        </div>
      </div> */}
      {/* <div className="stepper-main">
        <div className="round-button">
          <img src={clockIcon} className="clock-icon" alt="clock icon" />
        </div>
        <div className="disabled-step"></div>
        <div className="disabled-step"></div>
      </div> */}
      <div>
        {isSetupPasswordDialog && (
          <SetupPassword
            closeDialog={() => handleSetupPasswordDialog(false)}
            email={ibsService.currentUser.user.email}
            name={ibsService.currentUser.user.name}
            ibsService={ibsService}
            changePassword={false}
          />
        )}
      </div>
      <TabButtons
        estimateDetails={estimateDetails}
        report={report}
        currProgress={currProgress}
        dashboardSelectedTab={dashboardSelectedTab}
        isEstimateVisible={isEstimateVisible}
        handleDashboardSelectedTab={handleDashboardSelectedTab}
      />
      <CurrentStatus
        status={estimateDetails.assessmentStatus || "-"}
        comments={augmentedNotes}
        onRequestCallback={() => { /* handle callback */ }}
        onSendMessage={() => { /* handle message */ }}
        ibsService={ibsService}
        ibsAdonisService={ibsAdonisService}
        estimateDetails={estimateDetails}
        notes={estimateDetails.notes || []}
        notesSuggestions={notesSuggestions}
        showHideLoader={() => { }}
        notesAdded={refreshNotes}
        newMessage={() => { }}
        currentUser={ibsService.currentUser?.user}
      />
    </>
  );
};

export default Dashboard;
